module.exports = __webpack_public_path__ + "img/DSC_2648-xl.be69536e.png";